import {
  Box,
  CircularProgress,
  Modal,
  OutlinedInput,
  TextField,
  Typography,
} from "@mui/material"
import React from "react"
import {
  ButtonWrapper,
  CancelButton,
  OpportunityButtons,
  OpportunityDetailsSubWrapper,
  OpportunityDetailsWrapper,
  OpportunityFields,
  OpportunityMerticField,
  OpportunityMerticFieldTwo,
  OpportunityModalHeader,
  SetButton,
  style,
} from "../EditBenchmark/Atom"
import CloseIcon from "@mui/icons-material/Close"

type modalProps = {
  open: boolean
  metric: any
  closeHandler: any
  setEditedMetric: any
  setNewMetric: any
}

const EditMetricModal = (props: modalProps) => {
  const { open, metric, closeHandler, setNewMetric } = props
  const { setEditedMetric } = props
  const [loading, setLoading] = React.useState({
    now: false,
    message: false,
  })

  const changeHandler = (e: any) => setNewMetric(e.target.value)
  const handleClose = () => {
    closeHandler()
  }

  const handleClickSubmit = async () => {
    setLoading({ now: true, message: true })

    await setEditedMetric()

    setLoading({ now: false, message: false })
    handleClose()
  }

  const isDisabled = React.useMemo(() => {
    return metric.old === metric.new?.trim() || metric.new === ""
  }, [metric.new])

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      {loading.now ? (
        <Box
          sx={{
            ...style,
            flexDirection: "column",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flex: 1,
          }}
        >
          <CircularProgress />
          {loading.message ? (
            <Typography
              sx={{
                mt: "10px",
                mx: "40px",
                textAlign: "center",
                lineHeight: 2,
              }}
            >
              Updating metric name from <b>{metric.old}</b> to{" "}
              <b>{metric.new}</b>
            </Typography>
          ) : (
            <></>
          )}
        </Box>
      ) : (
        <Box sx={style}>
          <OpportunityModalHeader>
            <Typography>Edit Metric Name</Typography>
            <CloseIcon sx={{ cursor: "pointer" }} onClick={handleClose} />
          </OpportunityModalHeader>

          <OpportunityDetailsWrapper>
            <OpportunityDetailsSubWrapper>
              <OpportunityFields>
                <OpportunityMerticField>
                  <OpportunityMerticFieldTwo>
                    <Typography
                      fontSize={14}
                      sx={{
                        paddingBottom: "7px",
                      }}
                    >
                      Enter new metric name *
                    </Typography>
                    <TextField
                      autoFocus
                      fullWidth
                      value={metric?.new}
                      placeholder="Metric name"
                      onChange={changeHandler}
                      onKeyDown={(e: any) => {
                        if (e.key === "Enter") {
                          e.preventDefault()
                          if (!isDisabled) {
                            handleClickSubmit()
                          }
                        }
                      }}
                    />
                  </OpportunityMerticFieldTwo>
                </OpportunityMerticField>
              </OpportunityFields>
            </OpportunityDetailsSubWrapper>
          </OpportunityDetailsWrapper>

          <OpportunityButtons>
            <ButtonWrapper>
              <CancelButton onClick={handleClose}>Cancel</CancelButton>
              <Box>
                <SetButton onClick={handleClickSubmit} disabled={isDisabled}>
                  Submit
                </SetButton>
              </Box>
            </ButtonWrapper>
          </OpportunityButtons>
        </Box>
      )}
    </Modal>
  )
}

export default EditMetricModal
